import { Modal, Button } from "antd";
import "./adminNotification.css";
import { timeFormat } from "./notificationUtility";
import { InfoCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GalkButton from "../component/button";

const AdminNotification = ({ isModalVisible, setIsModalVisible, data }) => {
	const { t } = useTranslation();
	const handleOk = () => {
		setIsModalVisible(false);
		if (!data?.isRead) {
		}
	};

	const title = (
		<div id="headId">
			<div>
				<InfoCircleOutlined />
			</div>
			<div>Notification from Admin</div>
		</div>
	);

	if (!data || !isModalVisible) return null;
	return (
		<>
			<Modal
				title={title}
				footer={[
					<GalkButton key="submit" width={90} type="primary" onClick={handleOk}>
						OK
					</GalkButton>,
				]}
				visible={isModalVisible}
				onCancel={handleOk}
				width={400}
			>
				<div id="titleId">{data?.title}</div>
				<div className="timeId">
					<ClockCircleOutlined /> &nbsp;
					{timeFormat(data?.date.toDate())}
				</div>
				<div className="textId">{data?.text}</div>
			</Modal>
		</>
	);
};

export default AdminNotification;
